import "./Bag.css"
import Product1 from "../Components/Product1"
import Bag1 from "../images/b1.jpg"
import Bag2 from "../images/b2.jpg"
import Bag3 from "../images/b3.jpg"
import Bag4 from "../images/b4.jpg"
import Bag5 from "../images/b5.jpg"
import Bag6 from "../images/b6.jpg"
import Bag7 from "../images/b7.jpg"
import Bag8 from "../images/b8.jpg"
import Bag9 from "../images/bagmadd.jpg"
export default function Bag() {

  return (
    <div className="stdivinhome">
      <div className="add"><img src={Bag9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <strong><Product1 id="bag1" prdName="TOMMY_HILL" img={Bag1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1></strong>
            <strong>  <Product1  id="bag2"prdName="PUMA" img={Bag2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          </strong>

          </div>

          <div className="home__prd1">

          
          <Product1  id="bag3" prdName="PRIORITY" img={Bag3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="bag4" prdName="AMERICN_T" img={Bag4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="bag5"prdName="SKYBAGS" img={Bag5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="bag6"prdName="VOGUE" img={Bag6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="bag7" prdName="AMERICAN_T" img={Bag7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="bag8" prdName="SOLIMO" img={Bag8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}